import React from "react";
import img119 from "../../assets/carousel/image 119.png";
import img120 from "../../assets/carousel/image 120.png";
import img121 from "../../assets/carousel/image 121.png";
import img122 from "../../assets/carousel/image 122.png";
import img123 from "../../assets/carousel/image 123.png";
import './Carousel.css'

const Carousel = ({ mode }) => {
  return (
    <div
      id="carouselExampleControls"
      className={`carousel slide ${mode}`}
      data-bs-ride="carousel"
    >
      <div className="carousel-inner">
        <div className="carousel-item active first-active">
          <div className="herologocontainer">
            <img src={img119} alt=""/>
            <img src={img120} alt="" />
            <img src={img121} alt="" />
            <img src={img122} alt="" />
            <img src={img123} alt="" />
          </div>
        </div>
        <div className="carousel-item">
          <div className="carousel-card-holder">
            <img src={img119} alt="" style={{
              marginRight: '50px'
            }}/>
            <div className="carousel-card">
              <p className="carousel-card-heading">Zyeta</p>
              <p className="carousel-card-subheading">Video chat shouldn’t be awkward. Walking in and out of conversations feels natural and seamless</p>
            </div>
          </div>
        </div>
        <div className="carousel-item">
          <div className="carousel-card-holder">
            <img src={img120} alt="" style={{
              marginRight: '50px'
            }}/>
            <div className="carousel-card">
              <p className="carousel-card-heading">Bluelearn</p>
              <p className="carousel-card-subheading">Video chat shouldn’t be awkward. Walking in and out of conversations feels natural and seamless</p>
            </div>
          </div>
        </div>
        <div className="carousel-item">
          <div className="carousel-card-holder">
            <img src={img121} alt="" style={{
              marginRight: '50px'
            }}/>
            <div className="carousel-card">
              <p className="carousel-card-heading">Newton School</p>
              <p className="carousel-card-subheading">Video chat shouldn’t be awkward. Walking in and out of conversations feels natural and seamless</p>
            </div>
          </div>
        </div>
        <div className="carousel-item">
          <div className="carousel-card-holder">
            <img src={img122} alt="" style={{
              marginRight: '50px'
            }}/>
            <div className="carousel-card">
              <p className="carousel-card-heading">Draper Startup House</p>
              <p className="carousel-card-subheading">Video chat shouldn’t be awkward. Walking in and out of conversations feels natural and seamless</p>
            </div>
          </div>
        </div>
        <div className="carousel-item">
          <div className="carousel-card-holder">
            <img src={img123} alt="" style={{
              marginRight: '50px'
            }}/>
            <div className="carousel-card">
              <p className="carousel-card-heading">100ms</p>
              <p className="carousel-card-subheading">Video chat shouldn’t be awkward. Walking in and out of conversations feels natural and seamless</p>
            </div>
          </div>
        </div>
      </div>
      <button
        className={`carousel-control-prev ${mode}-controllers`}
        type="button"
        data-bs-target="#carouselExampleControls"
        data-bs-slide="prev"
      >
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button
        className={`carousel-control-next ${mode}-controllers`}
        type="button"
        data-bs-target="#carouselExampleControls"
        data-bs-slide="next"
      >
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  );
};

export default Carousel;
